import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

// App custom scheme (cleaner-app `app.json` → expo.scheme = "wiseclean-cleaner").
const APP_SCHEME = 'wiseclean-cleaner';

// Deep-link path segment for the schedule tab. Expo Router omits the route
// group "(tabs)" from the public URL, so the external deep link is
// "wiseclean-cleaner://schedule?date=...". The in-app router.push uses the
// group-qualified "/(tabs)/schedule" (different API, same screen).
const SCHEDULE_PATH = 'schedule';

// Store fallback URLs (canonical platform values — see README.md).
const STORE_URL_IOS = 'https://apps.apple.com/app/id6761757045';
const STORE_URL_ANDROID =
    'https://play.google.com/store/apps/details?id=eu.wiseclean.cleaner';

// How long to wait for the app to grab the scheme before bouncing to the store.
const FALLBACK_DELAY_MS = 1500;

// Strict YYYY-MM-DD shape — matches the date the ws1 Telegram button builds via |substr:0:10.
const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

const pickStoreUrl = () => {
    const ua = (navigator.userAgent || navigator.vendor || '').toLowerCase();
    if (/android/.test(ua)) return STORE_URL_ANDROID;
    if (/iphone|ipad|ipod/.test(ua)) return STORE_URL_IOS;
    // Desktop / unknown — default to the iOS listing (cleaners are iOS-heavy).
    return STORE_URL_IOS;
};

const OpenSchedule = () => {
    const [searchParams] = useSearchParams();
    const date = searchParams.get('date');
    const [invalid, setInvalid] = useState(false);

    useEffect(() => {
        // Validate the date before building any scheme URL.
        if (!date || !DATE_RE.test(date)) {
            setInvalid(true);
            return undefined;
        }

        // 1. Try to open the schedule tab (on the given day) inside the app.
        window.location.href = `${APP_SCHEME}://${SCHEDULE_PATH}?date=${date}`;

        // 2. If the app is not installed, bounce to the store after a short delay.
        const timer = setTimeout(() => {
            window.location.href = pickStoreUrl();
        }, FALLBACK_DELAY_MS);

        return () => clearTimeout(timer);
    }, [date]);

    if (invalid) {
        return (
            <div style={styles.container}>
                <p style={styles.text}>Неверная ссылка.</p>
            </div>
        );
    }

    return (
        <div style={styles.container}>
            <p style={styles.text}>Открываем приложение…</p>
        </div>
    );
};

const styles = {
    container: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        fontFamily: 'Arial, sans-serif',
        textAlign: 'center',
    },
    text: { fontSize: '18px', color: '#555' },
};

export default OpenSchedule;
